module.exports = __webpack_public_path__ + "img/jobView-unselected.a96dbabe.svg";